import { initDarkMode } from '~/composables/useDarkMode'

export default defineNuxtPlugin({
  name: 'dark-mode',
  parallel: true,
  setup() {
    initDarkMode()
  },
})
